<template>
  <div id="global" class="align-center">
    <div id="secundaria">
      <v-icon large>mdi-eye-off</v-icon>

      <p class="mt-2">Conteúdo Bloqueado</p>

      <v-divider v-if="!bloquear_hist_faturamento" class="mt-n2"></v-divider>

      <v-btn
        v-if="!bloquear_hist_faturamento"
        text
        small
        class="mt-1"
        @click="$emit('ver-conteudo', true)"
      >
        Ver conteúdo
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bloquear_hist_faturamento: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const bloquear_hist_faturamento = props.bloquear_hist_faturamento;
    return {
      bloquear_hist_faturamento
    }
  },
}
</script>
<style scoped>
#global {
  height: 100%;
  text-align: center;
  background-color: rgba(241, 241, 241, 0.4);
  border-radius: 5px;
}
#secundaria {
  position: relative;
  top: 50%;
  width: 250px;
  transform: translateY(-50%);
  margin-left: auto;
  margin-right: auto;
}

</style>
